import 'es6-promise/auto'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import VueAxios from 'vue-axios'
import Icon from 'vue-awesome/components/Icon'
import store from './store/store'
import Snotify from 'vue-snotify';
import moment from "moment";
import VueMomentJS from "vue-momentjs";
import ToggleButton from 'vue-js-toggle-button';
import VueMq from 'vue-mq'
import Multiselect from 'vue-multiselect'
import VueQuillEditor, { Quill } from 'vue-quill-editor'
import InputTag from 'vue-input-tag'
import VueSweetalert2 from 'vue-sweetalert2';


import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'vue-snotify/styles/material.css'; // or dark.css or simple.css
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-awesome/icons';
import 'vue-multiselect/dist/vue-multiselect.min.css';


Vue.use(VueSweetalert2);
Vue.component('input-tag', InputTag);
Vue.use(VueQuillEditor, /* { default global options } */)
// Vue.use(Datetime)
Vue.use(ToggleButton)
Vue.use(VueMomentJS, moment);
Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(Snotify, {
  toast: {
    timeout: 3000,
    position: 'rightTop',
    titleMaxLength: 25,
    bodyMaxLength: 250
  }
});
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    xs: 361,
    sm: 421,
    md: 1025,
    lg: Infinity,
  }
});

Vue.component('multiselect', Multiselect)

Vue.component('icon', Icon)

// localStorage.setItem('hostnames',['http://ucs.kovista.local',])
// localStorage.setItem('hostnames',['http://ucs1.gskills.com.sa',])
localStorage.setItem('hostnames',['https://system.alnokhbamarkets.com',])

const reqInterceptor = axios.interceptors.request.use(config => {
  console.log('Request Interceptor', config)
  return config
})
const resInterceptor = axios.interceptors.response.use(res => {
  console.log('Response Interceptor', res)
  return res
})

// window.hostnames = ['http://ucs.kovista.local']
// window.hostnames = ['http://ucs1.gskills.com.sa']
window.hostnames = ['https://system.alnokhbamarkets.com']

axios.interceptors.request.eject(reqInterceptor)
axios.interceptors.response.eject(resInterceptor)
// axios.defaults.baseURL = 'http://ucs.kovista.local'
// axios.defaults.baseURL = 'http://ucs1.gskills.com.sa'
axios.defaults.baseURL = 'https://system.alnokhbamarkets.com'

axios.defaults.headers.get['Accepts'] = 'application/json'
axios.defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.get['Authorization'] = 'Bearer '+ localStorage.getItem('token')

axios.defaults.headers.post['Accepts'] = 'application/json'
axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.post['Authorization'] = 'Bearer '+ localStorage.getItem('token')



axios.defaults.headers.put['Content-type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.put['Accepts'] = 'application/json'
axios.defaults.headers.put['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.put['Authorization'] = 'Bearer '+ localStorage.getItem('token')

axios.defaults.headers.delete['Content-type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.delete['Accepts'] = 'application/json'
axios.defaults.headers.delete['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.delete['Authorization'] = 'Bearer '+ localStorage.getItem('token')


router.beforeEach((to, from, next) => {
  store.dispatch('auth/tryAutoLogin');
  const now = new Date();
  const expiry = new Date(store.state.auth.expiryDate);
  if(
      to.path === '/' ||
      to.path === '/homepage' ||
      to.path === '/waffir' ||
      to.path === '/terms' ||
      to.path === '/pendings' ||
      to.path === '/confirm'
  ) { next(); } else{
    if(
        to.path === '/register' ||
        to.path === '/login'
    ) {
      if(store.state.auth.idToken !== null && expiry >= now){next('/dashboard')} next();
    } else{
      if (store.state.auth.idToken !== null && expiry >= now) {next()} else {const path = '/login?redirect=' + from.path; next(path);}
    }
  }

})

Vue.config.productionTip = false


new Vue({
  el: '#app',
  router, store,
  components: { App },
  template: '<App/>'

})



// WEBPACK FOOTER //
// ./src/main.js